import type { FaireProductEntity } from "../../entity_types/product";

export const p_u89h2h4qq2: FaireProductEntity = {
  token: "p_u89h2h4qq2",
  type: "product",
  name: "Waku Prebiotic Herbal Tea Peach - CANS",
  brandToken: "b_eou4scycuf",
  brandName: "Waku",
  imageUrl:
    "https://cdn.faire.com/fastly/c9773325b6cb56b4e03aed4b08c0878b5320f00f00f315503a5138183dd25dd2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da31581098046cfd4aeedab8be6eaa358d083d67f7a99ba09d4babd728ca5261.jpeg",
    "https://cdn.faire.com/fastly/1836d30371c1c4c391c1fd09eed7e826a245b34f2344db2152d1604a57935ff0.jpeg",
    "https://cdn.faire.com/fastly/8d9b087e206ddb23d1b23fdf861c3f7df92d4d6de3d2611b87442ab1ab392f27.jpeg",
    "https://cdn.faire.com/fastly/dbcd72a85479434bceae03a3ddc00e30da12dc97b463519d9e8da47baa52c707.jpeg",
    "https://cdn.faire.com/fastly/792b22e3e3edce2b1f8b69a0d8d1d3eabf529ffde38d1d7565d002b89ec35ac9.jpeg",
  ],
  priceDollars: 1.84,
  description:
    "Revel in the sun-kissed flavor of Waku Peach. With every sip, you’re greeted by a delightful blend of sweet and slightly sour notes that create a refreshing and invigorating experience. This unique flavor captures the essence of juicy peaches, providing a tantalizing balance of sweetness and acidity. One of our most refreshing flavors, Waku Peach offers a taste that’s both satisfying and revitalizing!\n\nWaku Peach Tasting Notes: Mild sweetness and delicate taste!\n\nWaku is: Vegan, Caffeine Free, Gluten Free, Non-GMO.\n\nWaku is sweetened with natural Monk Fruit to boost the flavor of the natural fruit juice without adding any sugar.\n\n*Each case contains twelve (12) 12 oz. CANS of Waku Prebiotic Herbal Tea Peach.",
  tags: [],
  msrpDollars: 4.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:13.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
